import { Section, SHELL } from '@/components/base/Frame';
import SelectedWorkWorkflow from './SelectedWorkWorkflow';

/* 04 / SELECTED WORK — macro rhythm: statement → workflow → lightweight outcome strip. */

const OUTCOMES = [
  ['FROM', 'MANUAL COORDINATION'],
  ['TO', 'ORCHESTRATED WORKFLOW'],
  ['HUMAN REVIEW', 'PRESERVED'],
  ['CRM', 'CONNECTED'],
] as const;

export default function SelectedWork() {
  return (
    <Section id="selected-work" divider className="relative overflow-hidden isolate">
      <div className={`${SHELL} relative flex min-h-0 flex-1 flex-col overflow-hidden`}>
        <div className="swk">
          <header className="swk-header">
            <div>
              <div className="swk-kicker">
                <span className="swk-kicker-index">04</span>
                <span>/</span>
                <span>SELECTED WORK</span>
              </div>
              <h2 id="selected-work-title">One workflow, rebuilt end to end.</h2>
              <p className="swk-support">
                See how a manual customer-operations workflow becomes a connected system with AI and human review
                working together.
              </p>
            </div>
            <p className="swk-meta">CUSTOMER OPERATIONS / REPRESENTATIVE ENGAGEMENT</p>
          </header>

          <div className="swk-field">
            <SelectedWorkWorkflow className="swk-workflow" />
          </div>

          <dl className="swk-outcomes" aria-label="Engagement outcome">
            {OUTCOMES.map(([k, v]) => (
              <div key={k} className="swk-outcome">
                <dt>{k} /</dt>
                <dd>{v}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
      <style>{styles}</style>
    </Section>
  );
}

const styles = `
.swk{
  --sk-paper:#ffffff;--sk-muted:#687386;--sk-steel-2:#e7ebf0;--sk-blue:#0f62fe;
  background:var(--sk-paper);color:#222a4c;height:100%;display:flex;flex-direction:column;
  min-height:0;overflow:hidden;position:relative;isolation:isolate;
}
.swk-header{
  padding:20px 34px 16px;display:flex;justify-content:space-between;gap:48px;align-items:flex-end;
  border-bottom:1px solid var(--sk-steel-2);flex:0 0 auto;background:oklch(var(--primary-50) / .7);
}
.swk-kicker{display:flex;gap:9px;align-items:center;margin-bottom:16px;font-family:var(--font-label);font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:oklch(var(--foreground-700));}
.swk-kicker-index{color:var(--sk-blue)}
.swk-header h2{margin:0;font-family:var(--font-heading);font-weight:300;font-size:clamp(30px,2.9vw,42px);line-height:1.1;letter-spacing:-.02em;color:oklch(var(--foreground-950));}
.swk-support{margin:10px 0 0;max-width:680px;color:var(--sk-muted);font:400 14px/1.45 "Geist","IBM Plex Sans",ui-sans-serif,system-ui,sans-serif;}
.swk-meta{margin:0;padding-bottom:5px;white-space:nowrap;color:var(--sk-muted);font:500 10px/1 "Geist Mono","IBM Plex Mono",ui-monospace,monospace;letter-spacing:.1em;}
.swk-field{flex:1 1 auto;min-width:0;min-height:0;display:flex;flex-direction:column;overflow:hidden;padding:16px 34px 12px;}
.swk-workflow{flex:1 1 auto;min-height:0;display:flex;flex-direction:column;}
.swk-field .swwl-stage{flex:1 1 auto;min-height:0;display:flex;align-items:flex-start;}
.swk-field .swwl-stage svg{width:100%;width:auto;max-width:100%;height:min(520px,50svh);max-height:100%;margin:0 auto;}
.swk-outcomes{
  flex:0 0 auto;margin:0;min-height:64px;padding:0 34px;display:flex;justify-content:space-between;gap:24px;
  align-items:center;border-top:1px solid var(--sk-steel-2);background:oklch(var(--primary-50) / .7);
  font:500 10px/1 "Geist Mono","IBM Plex Mono",ui-monospace,monospace;letter-spacing:.1em;
}
.swk-outcome{display:flex;gap:8px;min-width:0;white-space:nowrap;}
.swk-outcome dt{color:var(--sk-muted);}
.swk-outcome dd{margin:0;color:#222a4c;overflow:hidden;text-overflow:ellipsis;}
@media (max-width:1023px){
  .swk{height:auto;overflow:visible}
  .swk-field .swwl-stage svg{max-height:480px;}
}
@media (max-width:760px){
  .swk-header{flex-direction:column;align-items:flex-start;gap:16px;padding:20px 20px 16px;}
  .swk-meta{white-space:normal;line-height:1.5;}
  .swk-header h2{font-size:30px}
  .swk-field{padding:16px 0 0;overflow:visible}
  .swk-outcomes{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:14px 16px;padding:16px 20px;}
  .swk-outcome{flex-direction:column;gap:5px;white-space:normal;line-height:1.35}
  .swk-outcome dd{overflow:visible}
}
`;